/**
 * Card 스타일
 * @description 배경색은 tone × state 두 축이 함께 결정하므로 compoundVariants 로 조합을
 *   명시한다. 폭은 Fill, 높이는 Hug. 앱 `Card.styles.ts` 와 같은 표.
 */
import { cva } from "class-variance-authority";

export const cardStyles = cva(
  "w-full border-[length:var(--fw-border-sm)] border-[var(--fw-color-border-subtle)]",
  {
    variants: {
      tone: {
        neutral: "",
        /* 잠긴 면 — 상태 ramp 가 없어 축에서 바로 색을 준다 */
        secondary: "bg-[var(--fw-color-surface-neutral-secondary)]",
      },
      padding: {
        lg: "p-[var(--fw-space-inset-lg)]",
        md: "p-[var(--fw-space-inset-md)]",
      },
      radius: {
        lg: "rounded-[var(--fw-radius-lg)]",
        xs: "rounded-[var(--fw-radius-xs)]",
      },
      state: { rest: "", hovered: "", pressed: "", disabled: "" },
    },
    compoundVariants: [
      {
        tone: "neutral",
        state: "rest",
        class: "bg-[var(--fw-color-surface-neutral-primary)]",
      },
      {
        tone: "neutral",
        state: "hovered",
        class: "bg-[var(--fw-color-surface-neutral-primary-hovered)]",
      },
      {
        tone: "neutral",
        state: "pressed",
        class: "bg-[var(--fw-color-surface-neutral-primary-pressed)]",
      },
      {
        tone: "neutral",
        state: "disabled",
        class: "bg-[var(--fw-color-surface-neutral-disabled)]",
      },
    ],
    defaultVariants: {
      tone: "neutral",
      state: "rest",
      radius: "lg",
      padding: "lg",
    },
  },
);
